var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stations"},_vm._l((_vm.stations),function(station){return _c('Station',{key:station.uuid,attrs:{"station":station},on:{"select":function($event){return _vm.selectStation(station)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }